module.exports = require("./ff-Latn-GW");